export const categoriesEN = [
  {
    id: 'category1',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Annual/monthly gas consumption',
        heading:
          "Enter the company's gas consumption, Specify whether the value is monthly or annual. For monthly values, add before calculating.",
        doubt:
          'Clarify whether the consumption is provided on a monthly or annual basis and ensure unit consistency.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Consumption of other fossil fuels',
        heading:
          'Indicate consumption of fossil fuels other than natural gas. Specify the quantity in litres.',
        doubt:
          'Double-check the unit (litres) and apply the proper conversion factors as specified for diesel and fuel oil.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Number of company vehicles (cars/motorcycles)',
        heading:
          'Specify the number of company cars and motorbikes. Enter the type of vehicle, fuel and annual kilometers or liters consumed.',
        doubt:
          'Ensure you include all vehicles along with specific details like fuel type and usage to allow for accurate calculations.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Number of company vehicles (vans/trucks)',
        heading:
          'Indicate the number of company vans and trucks. Specify vehicle type and power supply.',
        doubt:
          'Record details for each van and truck accurately, paying attention to fuel type and annual usage metrics.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question5',
        done: false,
        title: 'Refrigeration systems',
        heading:
          'Indicate the use of refrigeration systems. Specify quantity and type of gas used or disposed of.',
        doubt:
          'Check the number of refills and ensure the gas type and weight per recharge are accurately recorded.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question6',
        done: false,
        title: 'Direct emissions from land use',
        heading:
          'Enter the annual amount of emissions resulting from land use activities within the reporting boundary. Emissions may include, for example, those from deforestation, land conversion, agricultural management, or other practices affecting land use.',
        doubt:
          'Confirm that the emissions are annual and in tonnes; adjust any unit conversions if necessary.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question7',
        done: false,
        title: 'Fugitive CO₂ emissions',
        heading:
          'Enter the annual amount of fugitive emissions generated within the reporting boundary. Fugitive emissions include unintentional releases such as leaks from pipelines, ventilation systems, landfills, refrigeration systems, or other emissions that are difficult to measure directly.',
        doubt:
          'Ensure all possible sources of fugitive emissions are included and the values are provided in tonnes.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question8',
        done: false,
        title:
          'What is the approach used to quantify differences in GHG emissions or removals?',
        heading:
          'Indicate the methodology used. Use recognized standards to ensure transparency in calculations.',
        doubt:
          'Detail the recognized methodology with examples if applicable to support transparency and accuracy in the calculations.'
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category2',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        hidden: true, // Cat 2 Q1 hidden per client request
        title: 'How much electricity has your organization imported during the reporting period?',
        heading: 'Enter the total amount of electricity consumed by your organization.',
        doubt: 'Select the correct period format as it influences how you fill in the subsequent consumption details.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title:
          'How much electricity has your organization purchased from the grid?',
        heading:
          'Enter the amount of electricity your organization has purchased from the national electricity grid.',
        doubt:
          'If you use grid electricity, ensure you provide both the consumption and details about the national energy mix for clarity.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Production of other forms of imported energy',
        heading:
          'Enter the quantity and type of energy (heat, steam, biogas, etc.) purchased from external suppliers.',
        doubt:
          'For imported energy, specify the type and accurately record the quantity using the correct energy unit.'
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category3',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Upstream transport and distribution of purchased goods',
        heading: '',
        doubt:
          'Only for inbound transport. Exclude VAT, surcharges, and customs duties.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Downstream transport and distribution',
        heading: '',
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Employee commuting',
        heading:
          'How many employees does your company have, and how do they commute? Please provide details on employee groups, transport modes, distances, trip frequency, and working hours.',
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Client and visitor transport',
        heading:
          'Please provide details about client and visitor travel to your offices: What are the main departure locations, destinations, transport modes, and travel frequencies? What are the estimated distances and associated emissions? Have any measures been taken to reduce travel-related emissions?',
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question5',
        done: false,
        title: 'Business travel',
        heading:
          'Please provide details about your business trips: What are the main destinations, transport modes, and travel frequencies? What are the estimated distances and associated emissions? For overnight trips, please include the typical room-nights per trip.',
        doubt: ''
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category4',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Purchased goods',
        heading:
          'During the reporting year, did your organisation buy any day-to-day goods (e.g. raw materials, packaging, office supplies, etc)?',
        doubt:
          'Only for inbound transport. Exclude VAT, surcharges, and customs duties.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Capital goods',
        heading:
          'During the reporting year, did your organisation purchase, construct or commission any capital goods that are capitalised on your balance sheet (e.g. buildings, machinery, vehicles, IT hardware, production lines, large tools)?',
        doubt:
          'Include capital equipment such as machinery, vehicles, or buildings. Exclude operating expenses and consumables.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Disposal of solid & liquid waste',
        heading:
          'During the reporting period, did your organisation send any solid or liquid waste to an external waste-management facility (e.g., sent to landfill, incinerated, recycled, or treated as wastewater)?',
        doubt:
          'Include disposal methods and quantities. Exclude emissions from the generation of waste itself.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: ' Use of assets (leased assets – lessee) ',
        heading:
          'During the reporting period, has your organization used rental or operating lease assets that are not capitalized on the balance sheet (e.g., rental buildings, rental or leased vehicles, rental machinery, equipment, or IT/office equipment)?',
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question5',
        done: false,
        title: 'Use of services not described above',
        heading:
          'During the reporting period, did your organisation purchase any professional or business services that were not physical goods, capital assets, waste management, or leased items?',
        doubt:
          'Include services like cleaning, IT support, and consulting. Exclude goods and employee travel already captured elsewhere.'
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category5',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Use stage of the product',
        heading:
          ' During the reporting year, did your organisation sell any products whose normal use by customers generates greenhouse gas emissions?',
        doubt:
          'Only for inbound transport. Exclude VAT, surcharges, and customs duties.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Downstream leased assets (lessor)',
        heading:
          'During the reporting period, did your organisation lease-out or rent-out any assets that you own but do not include in Scope 1 & 2 (because operational/financial control rests with the lessee)?',
        doubt:
          'Include capital equipment such as machinery, vehicles, or buildings. Exclude operating expenses and consumables.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: ' End-of-life of the product',
        heading:
          'During the reporting year, did your organisation sell any physical products (including their packaging) whose end-of-life disposal will be landfilled, incinerated, recycled, composted, or otherwise treated?',
        doubt:
          'Include disposal methods and quantities. Exclude emissions from the generation of waste itself.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Investments',
        heading:
          'During the reporting year, did your organisation hold any financial investments (equity, loans or project-finance) that are not already included in your scope 1 or scope 2 inventory?',
        doubt: ''
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category6',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Indirect GHG emissions from other sources',
        heading:
          'Does your organisation generate any other indirect GHG emissions or removals during the reporting year that do not fit into Categories 3-5?',
        doubt:
          'Only for inbound transport. Exclude VAT, surcharges, and customs duties.'
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  }
];

export const categoriesIT = [
  {
    id: 'category1',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Consumo di gas annuale/mensile',
        heading: "Inserire il consumo di gas dell'azienda",
        doubt:
          "Chiarire se il consumo è fornito su base mensile o annuale e garantire la coerenza dell'unità di misura."
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Consumo di altri combustibili fossili',
        heading:
          'Indicare il consumo di combustibili fossili diversi dal gas naturale',
        doubt:
          "Verificare l'unità di misura (litri) e applicare i fattori di conversione appropriati come specificato per diesel e olio combustibile."
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Numero di veicoli aziendali (auto/motocicli)',
        heading: 'Specificare il numero di auto e motocicli aziendali',
        doubt:
          "Assicurarsi di includere tutti i veicoli con dettagli specifici come il tipo di carburante e l'utilizzo per consentire calcoli accurati."
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Numero di veicoli aziendali (furgoni/camion)',
        heading: 'Indicare il numero di furgoni e camion aziendali',
        doubt:
          'Registrare accuratamente i dettagli per ogni furgone e camion, prestando attenzione al tipo di carburante e alle metriche di utilizzo annuale.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question5',
        done: false,
        title: 'Sistemi di refrigerazione',
        heading: "Indicare l'utilizzo di sistemi di refrigerazione",
        doubt:
          'Controllare il numero di ricariche e assicurarsi che il tipo di gas e il peso per ricarica siano registrati accuratamente.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question6',
        done: false,
        title: "Emissioni dirette dall'uso del suolo",
        heading:
          'Inserire la quantità annuale di emissioni derivanti da attività svolte su terreni inclusi nel perimetro di rendicontazione. Le emissioni possono includere, ad esempio, quelle derivanti da deforestazione, conversione del suolo, gestione agricola o altre pratiche che influenzano l’uso del suolo',
        doubt:
          'Confermare che le emissioni siano annuali e in tonnellate; regolare eventuali conversioni di unità se necessario.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question7',
        done: false,
        title: 'Emissioni fuggitive di CO₂',
        heading:
          "Inserire la quantità annuale di emissioni fuggitive generate all'interno del perimetro di rendicontazione. Le emissioni fuggitive includono rilasci non intenzionali come perdite da tubazioni, sistemi di ventilazione, discariche, sistemi di refrigerazione o altri rilasci difficili da misurare direttamente.",
        doubt:
          'Assicurarsi che siano incluse tutte le possibili fonti di emissioni fuggitive e che i valori siano forniti in tonnellate.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question8',
        done: false,
        title:
          "Qual è l'approccio utilizzato per quantificare le differenze nelle emissioni o negli assorbimenti di GHG?",
        heading: 'Indicare la metodologia utilizzata',
        doubt:
          "Dettagliare la metodologia riconosciuta con esempi se applicabile per supportare la trasparenza e l'accuratezza nei calcoli."
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category2',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        hidden: true, // Cat 2 Q1 hidden per client request
        title: 'Quanta elettricità è stata importata dalla vostra organizzazione nel periodo di riferimento?',
        heading: 'Inserisci la quantità totale di elettricità consumata dalla tua organizzazione.',
        doubt: 'Seleziona il formato del periodo corretto poiché influenza come compilerai i successivi dettagli di consumo.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title:
          'Quanta elettricità ha acquistato la tua organizzazione dalla rete?',
        heading:
          'Inserisci la quantità di elettricità che la tua organizzazione ha acquistato dalla rete elettrica nazionale.',
        doubt:
          'Se utilizzi elettricità dalla rete, assicurati di fornire sia il consumo che i dettagli sul mix energetico nazionale per maggiore chiarezza.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Importi altre forme di energia (calore, vapore, biogas, ecc.)?',
        heading: 'Quantità annuale di energia importata (kWh)',
        doubt:
          "Per l'energia importata, specificare il tipo e registrare accuratamente la quantità utilizzando l'unità di energia corretta."
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category3',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Trasporto e distribuzione a monte dei beni acquistati',
        heading:
          "Sono stati acquistati beni (materie prime, combustibili, componenti, imballaggi, materiali di consumo) da fornitori esterni durante l'anno di riferimento?",
        doubt:
          'Solo per il trasporto in entrata. Escludere IVA, sovrattasse e dazi doganali.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Trasporto e distribuzione a valle',
        heading:
          "Sono stati venduti o spediti beni finiti durante l'anno di riferimento?",
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Pendolarismo dei dipendenti',
        heading:
          'Quanti dipendenti ha la vostra azienda e come si recano al lavoro? Si prega di fornire dettagli sui gruppi di dipendenti, mezzi di trasporto, distanze, frequenza dei viaggi e orari di lavoro.',
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Trasporti di clienti e visitatori',
        heading:
          'Si prega di fornire dettagli sugli spostamenti di clienti e visitatori verso i vostri uffici: quali sono i principali luoghi di partenza, destinazioni, mezzi di trasporto e frequenza dei viaggi? Quali sono le distanze stimate e le emissioni associate? Sono state adottate misure per ridurre le emissioni legate ai viaggi?',
        doubt: ''
      },
      {
        answers: null,
        emissions: [],
        id: 'question5',
        done: false,
        title: 'Viaggi di lavoro',
        heading:
          'Si prega di fornire dettagli sui vostri viaggi di lavoro: quali sono le principali destinazioni, mezzi di trasporto e frequenza dei viaggi? Quali sono le distanze stimate e le emissioni associate? Per i viaggi con pernottamento, indicare il numero tipico di pernottamenti per viaggio.',
        doubt: ''
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category4',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Beni acquistati',
        heading:
          "Durante l'anno di rendicontazione, la vostra organizzazione ha acquistato beni di uso quotidiano (es. materie prime, imballaggi, forniture per ufficio, ecc.)?",
        doubt:
          'Solo per il trasporto in entrata. Escludere IVA, supplementi e dazi doganali.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: 'Beni capitali',
        heading:
          "Durante l'anno di rendicontazione, la vostra organizzazione ha acquistato, costruito o commissionato beni capitali iscritti nel bilancio come immobilizzazioni (es. edifici, macchinari, veicoli, hardware IT, linee di produzione, grandi attrezzature)?",
        doubt:
          'Includere attrezzature capitali come macchinari, veicoli o edifici. Escludere spese operative e materiali di consumo.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Smaltimento di rifiuti solidi e liquidi',
        heading:
          'Durante il periodo di rendicontazione, la vostra organizzazione ha inviato rifiuti solidi o liquidi a un impianto di gestione esterna dei rifiuti (ad esempio, discarica, incenerimento, riciclaggio o trattamento come acque reflue)?',
        doubt:
          'Includere metodi di smaltimento e quantità. Escludere le emissioni generate dalla produzione dei rifiuti stessi.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Uso di beni in leasing o a noleggio (locatario)',
        heading:
          'Nel periodo di rendicontazione, la vostra organizzazione ha utilizzato beni in noleggio o in leasing operativo che non sono capitalizzati a bilancio (ad es. edifici in affitto, veicoli a noleggio o in leasing, macchinari a noleggio, attrezzature o apparecchiature IT/ufficio)?',
        doubt:
          'Includere veicoli, edifici e attrezzature in leasing utilizzati dalla vostra organizzazione. Escludere i beni di proprietà.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question5',
        done: false,
        title: 'Uso di servizi non descritti sopra',
        heading:
          'Durante il periodo di riferimento, la tua organizzazione ha acquistato servizi professionali o aziendali che non fossero beni fisici, beni strumentali, gestione dei rifiuti o articoli in leasing?',
        doubt:
          'Includere servizi come pulizie, supporto IT e consulenze. Escludere beni e viaggi dei dipendenti già contabilizzati altrove.'
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category5',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Fase d’uso del prodotto',
        heading:
          'Durante l’anno di rendicontazione, la vostra organizzazione ha venduto prodotti il cui utilizzo normale da parte dei clienti genera emissioni di gas serra?',
        doubt:
          'Solo per il trasporto in entrata. Escludere IVA, supplementi e dazi doganali.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question2',
        done: false,
        title: ' Beni concessi in leasing o a noleggio (locatore)',
        heading:
          'Nel periodo di rendicontazione, la vostra organizzazione ha concesso in leasing o in noleggio beni di vostra proprietà, ma non inclusi nello Scope 1 & 2 (perché il controllo operativo/finanziario spetta al locatario/utilizzatore)?',
        doubt:
          'Includere attrezzature capitali come macchinari, veicoli o edifici. Escludere spese operative e materiali di consumo.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question3',
        done: false,
        title: 'Fine vita del prodotto',
        heading:
          'Durante l’anno di rendicontazione, la vostra organizzazione ha venduto prodotti fisici (inclusi gli imballaggi) il cui smaltimento a fine vita avverrà tramite discarica, incenerimento, riciclo, compostaggio o altro trattamento?',
        doubt:
          'Includere metodi di smaltimento e quantità. Escludere le emissioni derivanti dalla generazione dei rifiuti stessi.'
      },
      {
        answers: null,
        emissions: [],
        id: 'question4',
        done: false,
        title: 'Investimenti',
        heading:
          'Durante l’anno di rendicontazione, la vostra organizzazione ha detenuto investimenti finanziari (azioni, prestiti o project financing) che non sono già inclusi nel vostro inventario dello Scope 1 o 2?',
        doubt: ''
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  },
  {
    id: 'category6',
    done: false,
    questions: [
      {
        answers: null,
        emissions: [],
        id: 'question1',
        done: false,
        title: 'Emissioni indirette di gas serra da altre fonti',
        heading:
          'La vostra organizzazione genera altre emissioni o rimozioni indirette di gas serra durante l’anno di rendicontazione che non rientrano nelle Categorie 3-5?',
        doubt:
          'Solo per i trasporti in entrata. Escludere IVA, supplementi e dazi doganali.'
      }
    ],
    significanceMatrix: [],
    uncertaintyMatrix: [],
    emissionSource: '',
    dataSource: ''
  }
];
